import { ScanDetailsDrawerTab } from "./types";

export const SCAN_DETAILS_DRAWER_TABS: {
  id: ScanDetailsDrawerTab;
  label: string;
}[] = [
  { id: ScanDetailsDrawerTab.ScanDetails, label: "Scan details" },
  { id: ScanDetailsDrawerTab.AttachProviders, label: "Providers" },
  { id: ScanDetailsDrawerTab.Scope, label: "Scope" },
];
